import React, { useState, useEffect } from 'react';
import { Container, Button, Pagination, PaginationItem, Row, Col, Progress, Table, Input } from 'reactstrap';
import { PageCard } from "../components/card/PageCard";
import { PaginationLink } from "reactstrap";
import { useNavigate } from 'react-router-dom';
import { getPermissions } from "../hooks/permissionInstance"

function getStatusStyle(status) {
    switch (status) {
        case 'Active':
            return { color: '#00FF00' }; // Brighter green
        case 'Pending':
            return { color: '#DAA520' }; // Darker yellow
        default:
            return { color: 'red' };
    }
}

export const UserManagement = ({ finishAddingPipeline, existingPipelines }) => {
    const [permission, setPermissions] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [usersPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState(''); // State for the search term

    useEffect(() => {
        const fetchData = async () => {
            // Try to get the roles from sessionStorage
            const storedPermission = await getPermissions();
            if (storedPermission) {
                // If the roles are found, set them (after parsing to an object)
                setPermissions(storedPermission);
            } else {
                console.log("error while getting Permissions");
            }
        };
        fetchData(); // Call asynchronous function
    }, []);

    const searchInput = (
        <Input
            type="text"
            placeholder="Search by name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
        />
    );

    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const currentUsers = permission
        .filter(user => user.name.toLowerCase().includes(searchTerm.toLowerCase()))
        .slice(indexOfFirstUser, indexOfLastUser);

    const totalPages = Math.ceil(permission.length / usersPerPage);
    const [sortDirection, setSortDirection] = useState('asc'); // 'asc' or 'desc'
    const [sortedColumn, setSortedColumn] = useState('');

    let navigate = useNavigate();

    const sortUsers = (column) => {
        const sortedUsers = [...permission].sort((a, b) => {
            let itemA = a[column];
            let itemB = b[column];

            // For dates, you might need to create a Date object for correct comparison
            if (column === 'dateAdded') {
                itemA = itemA.split('-').reverse().join('-');
                itemB = itemB.split('-').reverse().join('-');
                itemA = new Date(itemA);
                itemB = new Date(itemB);
            } else {
                // Ensure the comparison is case insensitive for strings
                itemA = typeof itemA === 'string' ? itemA.toUpperCase() : itemA;
                itemB = typeof itemB === 'string' ? itemB.toUpperCase() : itemB;
            }

            if (itemA < itemB) {
                return sortDirection === 'asc' ? -1 : 1;
            }
            if (itemA > itemB) {
                return sortDirection === 'asc' ? 1 : -1;
            }
            return 0;
        });

        setPermissions(sortedUsers);
        // Toggle the sort direction for next time
        setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        // Update the sorted column
        setSortedColumn(column);
    };

    const cardBody = (
        <div style={{ minHeight: '60vh', display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
            <Table>
                <thead>
                    <tr>
                        <th style={{ width: '45%', cursor: 'pointer' }} onClick={() => sortUsers('name')}>
                            Name {sortedColumn === 'name' && (sortDirection === 'asc' ? '↑' : '↓')}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {currentUsers.map((role, index) => (
                        <tr key={index}>
                            <td>{role.name}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <div className="d-flex justify-content-between align-items-center ml-5 mr-5">
                <div>Showing {((currentPage - 1) * usersPerPage) + 1} to {((currentPage - 1) * usersPerPage) + currentUsers.length} of {permission.length} entries</div>

                <div>
                    <Pagination>
                        <PaginationItem disabled={currentPage === 1}>
                            <PaginationLink previous onClick={() => setCurrentPage(currentPage - 1)} />
                        </PaginationItem>

                        {[...Array(totalPages)].map((_, index) => (
                            <PaginationItem key={index} active={index + 1 === currentPage}>
                                <PaginationLink onClick={() => setCurrentPage(index + 1)}>{index + 1}</PaginationLink>
                            </PaginationItem>
                        ))}

                        <PaginationItem disabled={currentPage === totalPages}>
                            <PaginationLink next onClick={() => setCurrentPage(currentPage + 1)} />
                        </PaginationItem>
                    </Pagination>
                </div>
            </div>
        </div>
    )

    return (
        <PageCard cardName={"Permissions Overview"}
            cardBody={cardBody}
            searchBar={searchInput}
        />
    );
}

export default UserManagement;
